import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {CACHEABLE_WORKSPACE_ITEM_FULL_READ_INPUT, getProductCataloguesWithCaching, getProductCatalogueTemplatesWithCaching} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold/products")({
    loader: async ({context}) => {
        const [productCataloguesResult, productCatalogueTemplatesResult] = await Promise.all([
            getProductCataloguesWithCaching({
                workspaceId: context.workspace.id,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                queryClient: context.queryClient,
                ...CACHEABLE_WORKSPACE_ITEM_FULL_READ_INPUT,
            }),
            getProductCatalogueTemplatesWithCaching({
                workspaceId: context.workspace.id,
                intellsysBaseUrl: context.intellsysBaseUrl,
                accessToken: context.authenticationStatus.accessToken,
                queryClient: context.queryClient,
            }),
        ]);

        if (productCataloguesResult.success !== true) {
            throw new Error("Failed to fetch product catalogues");
        }

        if (productCatalogueTemplatesResult.success !== true) {
            throw new Error("Failed to fetch product catalogue templates");
        }

        return {
            productCatalogues: productCataloguesResult.data,
            productCatalogueTemplates: productCatalogueTemplatesResult.data,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
